import store from "@/store"

class Worker {
  init() {
    _$.vue.$on("worker", e => this.eventResolver(e))
    this.helperKeysListener()
    this.setAlarmClock(true)

    __.device.setMaxVolume().then(() => __.device.setDefaultVolume())

    if ([0, 1].includes(__.device.softAPState())) __.device.disableSoftAP()
    else __.device.enableSoftAP()

    _$.vue.$emit("worker.init", true)
  }
  helperKeysListener() {
    document.addEventListener("nv-source", e => this.eventHandler(e))
    document.addEventListener("nv-sleep-timer", e => this.eventHandler(e))
    document.addEventListener("nv-alarm-clock", e => this.eventHandler(e))
    document.addEventListener("nv-youtube", e => this.eventHandler(e))
    document.addEventListener("nv-netflix", e => this.eventHandler(e))
    document.addEventListener("nv-shahid", e => this.eventHandler(e))
    document.addEventListener("nv-prime", e => this.eventHandler(e))
    document.addEventListener("nv-browser", e => this.eventHandler(e))
    document.addEventListener("nv-cast", e => this.eventHandler(e))
    document.addEventListener("nv-movies", e => this.eventHandler(e))
    document.addEventListener("nv-tv", e => this.eventHandler(e))
    document.addEventListener("nv-epg", e => this.eventHandler(e))
    document.addEventListener("nv-list", e => this.eventHandler(e))
    document.addEventListener("nv-switch", e => this.eventHandler(e))
    document.addEventListener("nv-favorite", e => this.eventHandler(e))
    document.addEventListener("nv-ch_up", e => this.eventHandler(e))
    document.addEventListener("nv-ch_down", e => this.eventHandler(e))
    document.addEventListener("nv-red", e => this.eventHandler(e))
    document.addEventListener("nv-numerator", e => this.eventHandler(e))
  }
  eventHandler($event) {
    if (typeof $event !== "object" || !$event.type) return false
    this.eventResolver($event.type.replace("nv-", ""))
  }
  eventResolver(value) {
    if (!store.state.router || store.state.splash) return false

    switch (value) {
      case "source":
        __.source.select()
        break
      case "sleep-timer":
        this.setSleepTimer().catch(err => _$.error(err))
        break
      case "alarm-clock":
        this.setAlarmClock().catch(err => _$.error(err))
        break
      case "language-selection":
        this.setLanguage().catch(err => _$.error(err))
        break
      case "tv":
      case "epg":
      case "list":
        __.platform.go("/live")
        break
      case "switch":
        _$.vue.$emit("switch-channel", true)
        break
      case "favorite":
        _$.vue.$emit("favorite", true)
        break
      case "ch_up":
      case "ch_down":
        if (!store.state.routerHistory?.to.path.startsWith("/live")) __.platform.go("/live/all/osd")
        break
      case "youtube":
        __.app.launch("YOUTUBE")
        break
      case "netflix":
        __.app.launch("NETFLIX")
        break
      case "shahid":
        __.app.launch("net.mbc.shahid")
        break
      case "prime":
        __.app.launch("PRIME")
        break
      case "browser":
        __.app.launch("BROWSER")
        break
      case "cast":
        __.app.launch("CHROMECAST")
        break
      case "movies":
        __.platform.go("/vod")
        break
      case "red":
        this.syncData()
        break
      case "numerator":
        this_.$keyboard(document.getElementById("worker"), "numeric").then(() => this_.$channelSelectWithNumber({ detail: { value: "enter" } }, true))
        break
    }
  }
  async alarmForm() {
    let existed = _$.store.getItem("services.alarm-clock"),
      timeinput = null

    if (existed) {
      let _date = new Date(existed.value)
      timeinput = `${_$.pad(_date.getHours(), "00")}:${_$.pad(_date.getMinutes(), "00")}`
    }

    let result = await _$.vue.$interact.prompt(_$.vue.$t("Wake-Up Alarm"), _$.vue.$t("The TV will turn on at the time you specified."), "right", [
      { type: "time-selector", id: "time", value: timeinput },
      { type: "switch", label: "Activate", value: true }
    ])
    if (!result) return false

    if (!result.activate.value) {
      if (existed && existed.timeout) clearTimeout(existed.timeout)
      store.commit("services/alarm", null)
      _$.store.deleteItem("services.alarm-clock")

      if (existed.fidelio) {
        const { location } = __.device.get()
        __.api.fidelio.wakeupAnswer({ room: location, date: existed.value, status: "DE" })
      }

      return false
    }

    const date = new Date(),
      hm = result.time.value.split(":")

    date.setHours(hm[0])
    date.setMinutes(hm[1])
    date.setSeconds(0)

    return date
  }
  async clearAlarmClock() {
    let existed = _$.store.getItem("services.alarm-clock")
    if (!existed) return true

    if (existed.timeout) clearTimeout(existed.timeout)
    store.commit("services/alarm", null)
    _$.store.deleteItem("services.alarm-clock")

    if (existed.fidelio) {
      const { location } = __.device.get()
      __.api.fidelio.wakeupAnswer({ room: location, date: existed.value, status: "DE" })
    }

    return false
  }
  async setAlarmClock(refresh, fidelio = false) {
    let existed = _$.store.getItem("services.alarm-clock")
    if (refresh && !existed) return false

    let date = null
    if (!refresh && fidelio) date = fidelio
    else if (!refresh) date = await this.alarmForm()
    else date = new Date(existed.value)

    if (!date) return false

    let diff = date - new Date()
    if (refresh && diff / 1000 < -20) {
      store.commit("services/alarm", null)
      _$.store.deleteItem("services.alarm-clock")
      return false
    } else if (!refresh && diff <= 0) date.setDate(date.getDate() + 1)
    diff = date - new Date()

    let result = {
      value: date.getTime(),
      fidelio: fidelio ? true : false,
      timeout: setTimeout(() => {
        store.commit("services/alarm", null)
        _$.store.deleteItem("services.alarm-clock")

        const alarmMedia = {
          type: __.device.config("wakeup.wakeup_video") ? "video" : null,
          time: "alarm",
          path: __.device.config("wakeup.wakeup_video") || null
        }

        if (!__.device.isPowerOn()) {
          __.platform._openingMedia = alarmMedia
          __.device.powerOn()
        } else {
          if (["video", "image"].indexOf(alarmMedia.type) < 0) return
          _$.vue.$popup[alarmMedia.type](alarmMedia.path)
        }

        //TO DO Something

        if (fidelio) {
          const { location } = __.device.get()
          __.api.fidelio.wakeupAnswer({ room: location, date: date.getTime(), status: "OK" })
        }
      }, diff)
    }

    store.commit("services/alarm", result.value)
    _$.store.setItem("services.alarm-clock", result)
  }
  async setSleepTimer() {
    let existed = store.state.services.sleep

    let options = [
      { key: "300000", value: _$.vue.$tc("minute", 5) },
      { key: "600000", value: _$.vue.$tc("minute", 10) },
      { key: "900000", value: _$.vue.$tc("minute", 15) },
      { key: "1200000", value: _$.vue.$tc("minute", 20) },
      { key: "1800000", value: _$.vue.$tc("minute", 30) },
      { key: "2700000", value: _$.vue.$tc("minute", 45) },
      { key: "3600000", value: _$.vue.$tc("minute", 60) }
    ]

    if (existed) {
      options.unshift({ key: "delete", value: _$.vue.$t("Remove Current") })
      let _tempValue = existed.value.toString()
      options = options.map(option => {
        if (_tempValue === option.key) option.selected = true
        return option
      })
    }

    let result = await _$.vue.$sidepane(_$.vue.$t("Sleep Timer"), _$.vue.$t("The TV will turn off at the time you specified."), options, "right")
    if (!result) return false
    else result = { value: result }

    if (existed && existed.timeout) clearTimeout(existed.timeout)

    if (result.value === "delete") {
      store.commit("services/sleep", null)
      return false
    }

    result.timeout = setTimeout(() => {
      store.commit("services/sleep", null)
      // TODO: Do Something
      __.device.standBy()
    }, result.value)

    result.date = new Date()
    result.date.setSeconds(result.date.getSeconds() + result.value / 1000)
    store.commit("services/sleep", result)
  }
  async setLanguage() {
    const languages = Object.values(store.state.languages).map(language => {
      return { key: language.code, value: language.NAME, selected: store.getters.language === language }
    })

    languages.reverse()

    const res = await _$.vue.$sidepane(_$.vue.$t("Choose Language"), null, languages, "right")
    if (!res) return false

    return store.dispatch("setLanguage", res)
  }
  async syncData() {
    const res = await _$.vue.$interact.confirm(_$.vue.$t("All data will be refreshed. Do you confirm?"), null, "right")
    if (!res) return false
    return __.platform.syncData().then(() => __.app.syncAppList())
  }
}

export default new Worker()
